import { TERM_SECOND } from './term';

export const SWR_CONFIG = {
  revalidateOnFocus: false,
  errorRetryCount: 3,
  errorRetryInterval: TERM_SECOND * 5,
};
